import React from 'react';

import { BookOutlined, FlagOutlined, GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';

import { items } from './content';

const iconMap: Record<string, React.ReactNode> = {
  flag: <FlagOutlined className='mb-1 text-[35px]' />,
  book: <BookOutlined className='mb-1 text-[35px]' />,
  help: <QuestionCircleOutlined className='mb-1 text-[35px]' />,
  language: <GlobalOutlined className='mb-1 text-[35px]' />
};

const Actions = () => {
  return (
    <Row gutter={16}>
      {items.map(({ id, link, icon, title, description }) => (
        <Col key={id} xs={24} sm={12} md={6}>
          <a href={link} target='_blank' rel='noopener noreferrer'>
            <div className='bg-primary h-full w-full rounded-md px-4 py-6 text-center text-white transition-transform duration-300 hover:scale-105'>
              {iconMap[icon] || null}
              <p className='m-0! mt-2! font-bold'>{title}</p>
              <p className='m-0! text-[13px]'>{description}</p>
            </div>
          </a>
        </Col>
      ))}
    </Row>
  );
};

export default Actions;
